import collectionReducer from '../collectionReducer';

export default collectionReducer({
    apiCollectionName: 'apms',
    collectionActionName: 'APMS',
    itemActionName: 'MAILROOM',
});
